import Vue from 'vue'
import Router, { Route } from 'vue-router'
import About from './views/About.vue'
import LoggedIn from './views/LoggedIn.vue'
import Lov from './views/Lov.vue'
import Machines from './views/Machines.vue'
import Reports from './views/Reports.vue'
import Report from './views/Report.vue'
import Print from './views/Print.vue'
import Login from './views/Login.vue'

import Auth from '@/services/auth'

Vue.use(Router)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    component: LoggedIn,
    name: 'app',
    children: [
      {
        path: 'lov',
        name: 'lov',
        component: Lov,
        meta: { required: 'login' }
      },
      {
        path: 'reports',
        redirect: '/reports/0',
        meta: { required: 'login' }
      },
      {
        path: 'reports/:page',
        name: 'reports',
        component: Reports,
        meta: { required: 'login' }
      },
      {
        path: 'report/:id',
        name: 'report',
        component: Report,
        meta: { required: 'login' }
      },
      {
        path: 'report/:id/print',
        name: 'print',
        component: Print,
        meta: { required: 'login' }
      },
      {
        path: 'machines/',
        redirect: '/machines/0',
        meta: { required: 'login' }
      },
      {
        path: 'machines/:page',
        name: 'machines',
        component: Machines,
        meta: { required: 'login' }
      },
      {
        path: '*',
        name: 'about',
        component: About,
        meta: { required: 'login' }
      },
    ]
  }
]

var router = new Router({ routes })

router.beforeEach((to:any, from:any, next:any) => {
  if (to.meta && to.meta.required == 'login' && !Auth.shared.isSignedIn) {
    next(`/login?redirect=${to.fullPath}`)
    return
  }
  else {
    next()
  }
})

export default router